//=====================================================
//　チェックボックスベース
//=====================================================

import { useFormContext } from "react-hook-form"

interface IFProps {
    name: string,
    title: string,
    value: string,
    className: string,
    validations?: {}
}

export function InputCheckBase(props: IFProps) {

    const cf = useFormContext();

    //クラス名設定。対象にエラーがある場合はis-errorを付与。
    let tmpClass = props.className;
    if (cf.formState.errors[props.name]){
        tmpClass = tmpClass + " is-error";
    }

    return (
        <div className={"input-box-checkbox " + tmpClass}>
          <label htmlFor={props.name}>
              <input type="checkbox" id={props.name} value={props.value} {...cf.register(props.name, props.validations)} />
              <span className="agree-check-text">{props.title}</span>
          </label>
        </div>
    )

}